/**
 * Per-session identifier for the Explore deck memory feature.
 *
 * The backend (`/api/discover?session_id=<id>`) mixes this into the
 * shuffle seed. Same `session_id` → stable card order; new `session_id`
 * → freshly shuffled deck. On the web we scope this to the browser tab
 * via `sessionStorage`, so opening the app in a new tab / doing a hard
 * refresh gets a fresh order — matching the "new app launch" behaviour
 * on mobile.
 */
const KEY = "tb.explore.session_id";

function _randomId() {
  // Sufficient entropy for a per-tab shuffle seed; no crypto need.
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getSessionId() {
  try {
    let sid = window.sessionStorage.getItem(KEY);
    if (!sid) {
      sid = _randomId();
      window.sessionStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return _randomId();
  }
}

/** Force-regenerate the session_id so the next /discover call reshuffles
 * the deck. Called by ExploreDeckPage on mount so navigating away and
 * back to /explore always yields a fresh order. */
export function refreshSessionId() {
  const sid = _randomId();
  try { window.sessionStorage.setItem(KEY, sid); } catch { /* ignore */ }
  return sid;
}
